import React from "react";
import PropTypes from "prop-types";
import { Modal, Box, IconButton } from "@mui/material";
import { FaTimes } from "react-icons/fa";
import { ASSETS } from "../../../../utils/config";
import TextView from "../../../TextView";

const LegacyWheelModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <img
              src={ASSETS.segmentEditor.OldWheels}
              width={32}
              height={32}
              alt="Legacy Wheel Icon"
              style={{ marginRight: "10px" }}
            />
            <TextView variant="title">Legacy Wheel</TextView>
          </Box>
          <IconButton onClick={onClose}>
            <FaTimes />
          </IconButton>
        </Box>
        <TextView variant="text" style={{ marginTop: "10px" }}>
          {`This is a Legacy Wheel built with the version 1 Editor, which is no longer supported.`}
        </TextView>
      </Box>
    </Modal>
  );
};

LegacyWheelModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LegacyWheelModal;
